import { c as _c } from "react/compiler-runtime";
import { type ReactElement } from 'react';
import { useDrawingElementsProps } from '../hooks';
import useDrawingElements from '../hooks/useDrawingElements';
import type { ChartNakedInnerProps } from '../internalTypes';
import type { ChartDataRow } from '../types';
import ChartElement from './ChartElement';
import { FirstAxisNaked } from './FirstAxix';
import { SecondAxisNaked } from './SecondAxis';
const ChartNaked = t0 => {
  const $ = _c(31);
  const {
    chart,
    chartDrawing,
    drawingColorMaps,
    data,
    firstAxisDetails,
    secondAxisDetail,
    respectColors,
    elementsDescriptionsMap,
    firstAxisDomain,
    secondAxisDomain
  } = t0;
  const {
    type: chartType,
    layout: t1,
    firstAxis
  } = chart;
  const layout = t1 === undefined ? "horizontal" : t1;
  const {
    dataKey: firstAxisDataKey
  } = firstAxisDetails;
  let t2;
  if ($[0] !== secondAxisDetail) {
    t2 = [secondAxisDetail];
    $[0] = secondAxisDetail;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== chart || $[3] !== chartDrawing || $[4] !== drawingColorMaps || $[5] !== elementsDescriptionsMap || $[6] !== firstAxisDetails || $[7] !== respectColors || $[8] !== t2) {
    t3 = {
      chart,
      dimensionAxisDetails: firstAxisDetails,
      elementsDescriptionsMap,
      secondAxisDetails: t2,
      respectColors,
      chartDrawing,
      drawingColorMaps
    };
    $[2] = chart;
    $[3] = chartDrawing;
    $[4] = drawingColorMaps;
    $[5] = elementsDescriptionsMap;
    $[6] = firstAxisDetails;
    $[7] = respectColors;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const drawingElementsProps = useDrawingElementsProps(t3);
  let t4;
  if ($[10] !== data || $[11] !== drawingColorMaps || $[12] !== drawingElementsProps) {
    t4 = {
      drawingElementsProps,
      drawingColorMaps,
      data,
      polarHandlers: undefined
    };
    $[10] = data;
    $[11] = drawingColorMaps;
    $[12] = drawingElementsProps;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const drawingElements = useDrawingElements(t4);
  let t5;
  if ($[14] !== chartType || $[15] !== firstAxis || $[16] !== firstAxisDataKey || $[17] !== firstAxisDomain || $[18] !== layout) {
    t5 = <FirstAxisNaked id={firstAxis} chartType={chartType} layout={layout} firstAxisDomain={firstAxisDomain} dataKey={firstAxisDataKey} />;
    $[14] = chartType;
    $[15] = firstAxis;
    $[16] = firstAxisDataKey;
    $[17] = firstAxisDomain;
    $[18] = layout;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== layout || $[21] !== secondAxisDetail.axis || $[22] !== secondAxisDomain) {
    t6 = <SecondAxisNaked key={secondAxisDetail.axis} id={secondAxisDetail.axis} layout={layout} secondAxisDomain={secondAxisDomain} />;
    $[20] = layout;
    $[21] = secondAxisDetail.axis;
    $[22] = secondAxisDomain;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== chartType || $[25] !== data || $[26] !== drawingElements || $[27] !== layout || $[28] !== t5 || $[29] !== t6) {
    t7 = <ChartElement layout={layout} chartType={chartType} otherChartType={undefined} data={data}>{t5}{t6}{drawingElements}</ChartElement>;
    $[24] = chartType;
    $[25] = data;
    $[26] = drawingElements;
    $[27] = layout;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  return t7;
};
export default ChartNaked;